// extracted by mini-css-extract-plugin
export var active = "_2l-j";
export var cell = "_2l-3";
export var cellLoading = "_2l-6";
export var center = "_2l-10";
export var clickable = "_2l-c";
export var compact = "_2l-4";
export var container = "_2l-8";
export var data = "_2l-a";
export var dataRow = "_2l-b";
export var dateRangeContainer = "_2l-2";
export var downloadIcon = "_2l-v";
export var empty = "_2l-e";
export var filter = "_2l-g";
export var filterContainer = "_2l-16";
export var filterCount = "_2l-i";
export var filterLabel = "_2l-h";
export var filters = "_2l-f";
export var header = "_2l-l";
export var headerButton = "_2l-m";
export var headerContent = "_2l-n";
export var headerLabel = "_2l-p";
export var headerRow = "_2l-u";
export var headerSort = "_2l-o";
export var headerSortAsc = "_2l-r";
export var headerSortContainer = "_2l-q";
export var headerSortDesc = "_2l-s";
export var headerSpacer = "_2l-t";
export var headers = "_2l-w";
export var infoIcon = "_2l-1b";
export var left = "_2l-z";
export var loader = "_2l-y";
export var loaderContainer = "_2l-x";
export var main = "_2l-9";
export var movingGradient = "_2l-7";
export var options = "_2l-0";
export var pageChangeButton = "_2l-1a";
export var pageControl = "_2l-17";
export var pageControlSticky = "_2l-18";
export var pageNumbers = "_2l-19";
export var right = "_2l-11";
export var seamless = "_2l-1";
export var spacer = "_2l-12";
export var table = "_2l-14";
export var tableContainer = "_2l-13";
export var tableFitToParent = "_2l-15";
export var textHeader = "_2l-k";
export var title = "_2l-d";
export var wide = "_2l-5";